import React from 'react';
import "./About.css"; // ✅ Add this
import AboutSection from "../components/AboutSection";

const About = () => {
  return (
    <div className="about-container">
      <div className="about-card shadow-lg">
       <AboutSection />
       
      </div>
    </div>
  );
};

export default About;
